import FattyLiver from "../assets/Fatty Liver Score.png";
import PhysicalScore from "../assets/Physical Activity Score.png";
import MetabolicScore from "../assets/Metabolic Score.png";
import SleepSore from "../assets/Sleep Score.png";
import StressSore from "../assets/Stress Score.png";

import VataCopy from "../../assets/Prakriti/Vata-copy.png";
import VataPittaKapha from "../../assets/Prakriti/Vata-Pitta-Kapha.png";
import Pitta from "../../assets/Prakriti/Pitta.png";
import Kapha from "../../assets/Prakriti/Kapha.png";
import VataPitta from "../../assets/Prakriti/Vata-Pitta.png";
import VataKapha from "../../assets/Prakriti/Kapha-Vata.png";
import PittaKapha from "../../assets/Prakriti/Pitta-Kapha.png";
import Vata from "../../assets/Prakriti/Vata.png";
import { visibleScoreswithCustomers } from "../../utils/constants";

export const getScoreImage = (url) => {
  try {
    switch (url) {
      case "Fatty Liver Score":
        return FattyLiver;
      case "Physical Activity Score":
        return PhysicalScore;
      case "Metabolic Score":
        return MetabolicScore;
      case "Sleep Score":
        return SleepSore;
      case "Stress Score":
        return StressSore;
      case "Vikriti":
        return VataPittaKapha;
      case "Prakriti":
        return VataPittaKapha;
    }
  } catch (e) {
    console.log("Error from getScoreImage:", e);
    throw e;
  }
};

export const getPrakritiVikritiIcon = (name) => {
  try {
    switch (name) {
      case "Vata":
        return VataCopy;

      case "VATA":
        return VataCopy;

      case "Pitta":
        return Pitta;

      case "PITTA":
        return Pitta;

      case "Kapha":
        return Kapha;

      case "KAPHA":
        return Kapha;

      case "Vata-Pitta":
        return VataPitta;

      case "Vatta-Pitta":
        return VataPitta;

      case "Vata-Kapha":
        return VataKapha;

      case "Vata-Pitta-Kapha":
        return VataPittaKapha;

      case "Pitta-Kapha":
        return PittaKapha;
      default:
        return VataPittaKapha;
    }
  } catch (e) {
    console.log("Error from getPrakritiVikritiIcon:", e);
    throw e;
  }
};

export const customImage = (title) => {
  try {
    if (title === "Prakriti" || title === "Vikriti")
      return getPrakritiVikritiIcon("Vata-Pitta-Kapha");
    return `https://d3ggzbwb0yiai7.cloudfront.net/madmachines/Health_Score/${title}.png`;
  } catch (e) {
    console.log("pdf-Error from customImage:", e);
    throw e;
  }
};

export const getRoundedValue = (value, denominator, isSubtract) => {
  try {
    let scoreValue = value;
    let calculatedValue = (scoreValue / denominator) * 100;
    let roundedValue = Math.round(calculatedValue * 10) / 10;
    let finalValue = 100 - roundedValue;
    finalValue = Math.round(finalValue * 100) / 100;
    return isSubtract ? finalValue : roundedValue;
  } catch (e) {
    console.log("pdf-Error from getRoundedValue:", e);
    throw e;
  }
};

export const shouldShowScoreLabel = (item) => {
  try {
    if (!item.score?.label) return false; // Ensure label exists
    if (item.title === "Prakriti") {
      const responseLength = item.score.question_responses?.length || 0;
      return responseLength === 11 || responseLength === 35;
    }
    return true; // For other cases, just check for the label
  } catch (e) {
    console.log("pdf-Error from shouldShowScoreLabel:", e);
    throw e;
  }
};

export const calculateScore = (scoreName, score) => {
  try {
    const scoreMap = {
      "Physical Activity Score": [45, true],
      "Metabolic Score": [100, true],
      "Stress Score": [40, false],
      "Sleep Score": [18, false],
      "Fatty Liver Score": [100, false],
      Prakriti: [null, false],
    };
    const [maxValue, roundUp] = scoreMap[scoreName] || [];
    return maxValue !== null
      ? getRoundedValue(score, maxValue, roundUp)
      : score;
  } catch (e) {
    console.log("pdf-Error from calculateScore:", e);
    throw e;
  }
};

export const removeDuplicatesAndEmpty = (arr) => {
  const uniqueItems = Array.from(
    new Set(arr.filter((item) => item.trim() !== ""))
  );
  const result = uniqueItems.map((item) => item + " ");
  return result;
};

export const capitalizeWords = (str) => {
  const result =
    str.length > 0 && str.replace(/\b\w/g, (char) => char.toUpperCase());
  return result;
};

export const processScores = (scoreRes, showVikriti, vikritiRes) => {
  try {
    const scoresWithRecommendations = {};
    let name = "";
    if (scoreRes.status === "fulfilled" && scoreRes.value) {
      const data = scoreRes.value;
      const allowedScores = visibleScoreswithCustomers.healthians;

      if (data.recommendations.name?.length > 0) {
        name = capitalizeWords(data.recommendations.name);
      }
      if (showVikriti) {
        scoresWithRecommendations["Vikriti"] = vikritiRes;
      } else {
        delete data.recommendations.Vikriti;
      }
      Object.entries(data.recommendations || {}).forEach(
        ([scoreName, item]) => {
          if (
            allowedScores.includes(scoreName) &&
            scoreName !== "Vikriti" &&
            item?.recommendations &&
            Object.keys(item.recommendations).length > 0
          ) {
            const updatedScore = calculateScore(scoreName, item.score);
            scoresWithRecommendations[scoreName] = {
              ...item,
              score: updatedScore,
            };
          }
        }
      );
    }
    return { scoresWithRecommendations, name };
  } catch (e) {
    console.log("pdf-Error from processScores:", e);
    throw e;
  }
};

export const processVikriti = (vikritiRes) => {
  try {
    const result =
      vikritiRes.status === "fulfilled" &&
      vikritiRes.value?.vikrititRecomm?.recommendations?.length > 0 &&
      !vikritiRes.value.vikrititRecomm.recommendations.includes(
        "No recommendations"
      );
    return result;
  } catch (e) {
    console.log("pdf-Error from processVikriti:", e);
    throw e;
  }
};

export const createFirstPageScores = (
  scoresWithRecommendations = {},
  showVikriti = false
) => {
  try {
    return visibleScoreswithCustomers.healthians
      .map((key) => {
        const scoreData = scoresWithRecommendations[key];

        // Specific handling for Vikriti
        if (key === "Vikriti") {
          if (!showVikriti) {
            return null; // Skip Vikriti entirely
          }
          if (!scoreData?.value?.label) {
            return {
              name: key,
              content: "Not Filled",
              scoreLabel: null,
            };
          }

          return {
            name: key,
            content: scoreData.value.label,
            scoreLabel: scoreData.value.label.split(" ")[1] || null,
          };
        }

        // Scenario 1: Handle missing scoreData
        if (!scoreData) {
          return {
            name: key,
            content: "Not Filled",
            scoreLabel: null,
          };
        }

        // Scenario 3: Valid data for other keys
        if (
          scoreData.recommendations &&
          Object.keys(scoreData.recommendations).length > 0
        ) {
          let content =
            key === "Prakriti"
              ? `${scoreData.label}`
              : `${scoreData.score} / ${scoreData.max_score}`;
          return {
            name: key,
            content: content,
            scoreLabel: scoreData.score_label,
          };
        }

        // Default fallback for keys with incomplete data

        return {
          name: key,
          content: "Not Filled",
          scoreLabel: null,
        };
      })
      .filter(Boolean); // Remove null entries (e.g., skipped Vikriti)
  } catch (e) {
    console.error("Error in createFirstPageScores:", e);
    throw e;
  }
};

export const updateState = (scoresWithRecommendations, showVikriti) => {
  try {
    console.log("showVikriti-1", showVikriti);

    const firstPageScore = createFirstPageScores(
      scoresWithRecommendations,
      showVikriti
    );
    console.log("firstPageScore:", firstPageScore);

    if (Object.keys(scoresWithRecommendations).length > 0) {
      return {
        recommendation: scoresWithRecommendations,
        firstPageScore,
        error: null,
      };
    } else {
      return {
        scoresWithRecommendations: null,
        firstPageScore,
        error:
          "Your Health Score isn't ready yet. Please fill all the Questions.",
      };
    }
  } catch (e) {
    console.log("pdf-Error from updateState:", e);
    throw e;
  }
};

export const processRisks = (scoreRes) => {
  try {
    if (scoreRes.status === "fulfilled" && scoreRes.value?.risks) {
      const disease = Object.keys(scoreRes.value.risks).reduce(
        (acc, riskLevel) => {
          acc[riskLevel] = scoreRes.value.risks[riskLevel].map((risk) => {
            const updatedRisk = { ...risk };
            if (risk.about?.length > 0) {
              updatedRisk.about = removeDuplicatesAndEmpty(risk.about);
            }
            if (risk.recommendations?.length > 0) {
              updatedRisk.recommendations = risk.recommendations.map(
                removeDuplicatesAndEmpty
              );
            }
            if (risk["Risk Factors"]?.length > 0) {
              updatedRisk["Risk Factors"] = removeDuplicatesAndEmpty(
                risk["Risk Factors"]
              );
            }
            return updatedRisk;
          });
          return acc;
        },
        {}
      );
      return {
        riskError: null,
        processedDisease: disease,
        namefromRisk: capitalizeWords(scoreRes.value?.name ? scoreRes.value?.name : ""),
      };
    }
    return {
      riskError: "No valid risks found.",
      processedDisease: null,
      namefromRisk: capitalizeWords(scoreRes.value?.name ? scoreRes.value?.name : ""),
    };
  } catch (e) {
    console.log("pdf-Error from processRisks:", e);
    throw e;
  }
};
